import { CheckCircle, DoNotDisturb, ErrorOutline } from '@mui/icons-material';

import { HealthLevel, healthLevel } from '../../../dtos.ts';

type HealthIconProps = {
  healthLevels: HealthLevel[] | undefined;
  hideSuccessIcon?: boolean;
};

export const HealthLevelIcon = ({ healthLevels, hideSuccessIcon = false }: HealthIconProps) => {
  if (healthLevels === undefined) {
    return <p>...</p>; // Loading
  } else if (healthLevels.some((hl) => hl === healthLevel.ERROR)) {
    return <DoNotDisturb color="error" fontSize="medium" sx={{ verticalAlign: 'middle' }} />;
  } else if (healthLevels.some((hl) => hl === healthLevel.WARNING)) {
    return <ErrorOutline color="warning" fontSize="medium" sx={{ verticalAlign: 'middle' }} />;
  } else if (healthLevels.length === 0 && !hideSuccessIcon) {
    return <CheckCircle color="success" fontSize="medium" sx={{ verticalAlign: 'middle' }} />;
  } else {
    return <></>;
  }
};
